"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var init = function () {
    var $tabsButton = $('.tedee-tabs *[data-tab]');
    var $tabsContent = $('.tedee-tab-content');
    var activeClass = 'tedee-tabs__tab--active';
    var queryParams = new URLSearchParams(window.location.search);
    bindClickOnTabEvent();
    setTabsDefaultsState();
    function bindClickOnTabEvent() {
        $tabsButton.on('click', function (e) {
            showClickedTab($(this));
        });
    }
    window.addEventListener('popstate', function (e) {
    });
    function showClickedTab($clickedTab) {
        var contentId = '#' + $clickedTab.data('tab');
        var $content = $(contentId);
        $(document).trigger('tedeeTabChanged', [contentId]);
        queryParams.set('tab', $clickedTab.data('tab'));
        history.pushState({}, null, '?' + queryParams.toString());
        $clickedTab.siblings().removeClass(activeClass);
        $clickedTab.parent().parent().find('a').removeClass(activeClass);
        $clickedTab.addClass(activeClass);
        $content.siblings('.tedee-tab-content').removeClass(activeClass);
        $content.addClass(activeClass);
        $content.fadeIn(500);
        $content.siblings('.tedee-tab-content').hide();
    }
    function setTabsDefaultsState() {
        var tabParam = queryParams.get('tab'); //
        if (tabParam) {
            var $tabNav = $('.tedee-tabs');
            var $loadItem_1 = $tabNav.find("[data-tab=\"".concat(tabParam, "\"]")).first();
            var disableScrollToElement = $tabNav.data('noscroll') === true;
            $loadItem_1.trigger('click');
            if (!disableScrollToElement) {
                setTimeout(function () {
                    $('html, body').animate({
                        scrollTop: $loadItem_1.offset().top - 100
                    }, 200);
                }, 1000);
            }
        }
        else {
            $tabsContent.slice(1).removeClass(activeClass);
            $tabsContent.first().addClass(activeClass);
            $tabsContent.first().show();
            $tabsContent.slice(1).hide();
            $tabsButton.eq(0).addClass(activeClass);
        }
    }
};
exports.init = init;
